export const AVATAR_AI_POLL_INTERVAL_MS = 2000;
export const AVATAR_AI_POLL_MAX_MS = 90 * 1000;
export const AVATAR_AI_ACCEPTED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
];
export const AVATAR_AI_MAX_FILE_BYTES = 5 * 1024 * 1024;
export const AVATAR_AI_QUIP_ROTATE_MS = 2600;
export const MAX_AVATAR_AI_PARALLEL_JOBS = 6;

export const AVATAR_AI_STEPS = {
  PICKING: "PICKING",
  SUBMITTING: "SUBMITTING",
  RUNNING: "RUNNING",
  APPLIED: "APPLIED",
  ERROR: "ERROR",
};

export const AVATAR_AI_JOB_STATUS = {
  IN_QUEUE: "IN_QUEUE",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  APPLIED: "APPLIED",
};

export const isAvatarAiJobTerminal = (status) =>
  status === AVATAR_AI_JOB_STATUS.COMPLETED ||
  status === AVATAR_AI_JOB_STATUS.FAILED ||
  status === AVATAR_AI_JOB_STATUS.APPLIED;

export const getAvatarAiFileSizeBucket = (size = 0) => {
  if (size <= 100 * 1024) return "0-100kb";
  if (size <= 1024 * 1024) return "100kb-1mb";
  if (size <= 3 * 1024 * 1024) return "1mb-3mb";
  if (size <= 5 * 1024 * 1024) return "3mb-5mb";
  return "5mb+";
};

export const AVATAR_AI_GENERIC_QUIPS = [
  "Mescolo i pixel...",
  "Sussurro al modello AI...",
  "Aggiungo un pizzico di stile...",
  "Bilancio l'illuminazione...",
  "Sto sistemando i capelli ribelli...",
  "Polvere magica in arrivo...",
  "Lucidando i dettagli del viso...",
  "L'AI sta studiando la tua espressione...",
  "Cucinando il render perfetto...",
  "Quasi pronto, manca solo il fiocco...",
];

export const AVATAR_AI_THEME_QUIPS = {
  corporate: [
    "Sto annodando la cravatta...",
    "Lucidando le scarpe...",
    "Riunione importante in arrivo...",
  ],
  "linkedin-premium": [
    "Aggiungo lens flare professionale...",
    "Studiando l'algoritmo di LinkedIn...",
  ],
  "creative-pro": [
    "Selezione palette artistica...",
    "Aggiungo tocco creativo...",
  ],
  "editorial-bw": [
    "Convertendo i colori in dramma...",
    "Composizione da copertina...",
  ],
  "tech-founder": [
    "Caricando dolcevita Steve Jobs...",
    "Pitching alla prossima Series A...",
  ],
  "event-speaker": [
    "Accendo le luci del palco...",
    "Microfono in posizione...",
  ],
  "pixar-3d": [
    "Riggando il personaggio...",
    "Aggiungo occhioni espressivi...",
    "Render in subdivision...",
  ],
  "eighties-synthwave": [
    "Accendo i neon...",
    "Cotonando i capelli...",
    "Sintonizzo synth analogico...",
  ],
  superhero: [
    "Cucendo il mantello...",
    "Mantello in posa eroica...",
    "Sfondo drammatico in caricamento...",
  ],
  anime: [
    "Disegnando occhi grandi...",
    "Aggiungo riflessi shōjo...",
    "Sfumando con acquerello...",
  ],
  "roman-statue": [
    "Scolpendo il marmo...",
    "Polverizzando la toga...",
    "Studiando la posa classica...",
  ],
};

export const buildAvatarAiQuipsForTheme = (themeId) => {
  const themeSpecific = AVATAR_AI_THEME_QUIPS[themeId] || [];
  return [...themeSpecific, ...AVATAR_AI_GENERIC_QUIPS];
};
